
__webpack_require__.remotesLoadingData = { chunkMapping: {"623":["32394"]}, moduleIdToRemoteDataMapping: {"32394":{"shareScope":"default","name":"./UserDetails","externalModuleId":74062,"remoteName":"profile"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
